import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";

import MomentsUser from "../../components/MomentsUser";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import MainContainer from "../../components/MainContainer";
import { PageHeader, StatusBadge } from "../../components/ui";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
  const tk = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
  root: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    fontFamily: tk.font,
  },
  // só a área de rolagem: os cartões por atendente ficam direto sobre a página
  workspace: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    paddingRight: 4,
    paddingBottom: 4,
    ...theme.scrollbarStyles,
  },
}});

const ChatMoments = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  return user.profile === "user" && user.allowRealTime === "disabled" ? (
    <ForbiddenPage />
  ) : (
    <MainContainer>
      <div className={classes.root}>
        <PageHeader
          title={i18n.t("servicePanel.allowRealTime")}
          subtitle="Acompanhe a operação, a distribuição e as conversas ativas em tempo real."
          badge={<StatusBadge color="success" label="Ao vivo" />}
        />
        <section className={classes.workspace} aria-label="Operação em tempo real">
          <MomentsUser />
        </section>
      </div>
    </MainContainer>
  );
};

export default ChatMoments;
